<template>
  <div class="footer-container">
    <div class="link-box">
      <div class="left-box logo" ><img src="@/assets/footer/footer-logo.png" alt=""></div>
      <div class="center-box">
        <div class="link-box-item about">
          <div class="title">关于我们</div>
          <div class="content">
            <ul class="ul">
              <li>超声在线（北京）技术有限公司</li>
              <li>版权声明</li>
              <li>免责声明</li>
              <li>隐私政策</li>
            </ul>
          </div>
        </div>
        <div class="link-box-item links">
          <div class="title">合作单位</div>
          <div class="content">
            <ul class="ul">
              <li><a target="_blank" href="https://www.21wecan.com/wsrcw/index.shtml">国家卫健委人才交流服务中心</a></li>
              <li><a target="_blank" href="http://www.csecho.com.cn/cn/">中国超声心动图学会</a></li>
              <li><a target="_blank" href="http://www.leesmed.org/">李氏医学探索</a></li>
            </ul>
          </div>
        </div>
        <div class="link-box-item service">
          <div class="title">服务支持</div>
          <div class="content">
            <ul class="ul">
              <li>网站帮助</li>
              <li><a href="tel:010-85715255">010-85715255</a></li>
              <li><a href="mailto:echooline_membership@bj-ztjh.com">echooline_membership@bj-ztjh.com</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="img-box">
          <div><img src="@/assets/footer/gzh.png" alt=""/></div>
          <div>扫描关注</div>
          <div>超声在线公众号</div>
        </div>
        <div class="img-box">
          <div><img src="@/assets/footer/app.png" alt=""/></div>
          <div>扫描下载</div>
          <div>超声在线APP</div>
        </div>
      </div>
    </div>
    <footer class="footer">
      Copyright 2024-2025 echonline.cn 超声在线（北京）技术有限公司 版权所有
      <b></b>
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024081478号-3</a>
      <b></b>
      <img src="@/assets/gwab.png"/>
      京公网安备11010502056486号
    </footer>
  </div>

</template>

<script>
import {defineComponent} from "vue";
import {mapState} from "vuex";

export default defineComponent({
  name: "FooterBar",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState(["isFooterBarVisible"]),
  },
});
</script>

<style scoped lang="scss">
.footer-container {
  min-width: 1200px;
  --footer-img-margin: 0 50px;
  --footer-font-size: 12px;
}

.link-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: 20px auto 0 auto;
  padding: 42px;
  min-height: 275px;
  flex-wrap: wrap;

  .left-box {
    img {
      width: 260px
    }
  }

  .center-box {
    display: flex;
    justify-content: center;
    padding: 0 20px;
    gap: 20px;
    flex: 1;

    .link-box-item {
      padding: 20px;

      .title {
        font-size: var(--footer-font-size);
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 31px;
        color: rgba(56, 56, 56, 1);
        text-align: left;
      }

      .ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          font-size: var(--footer-font-size);
          font-weight: 400;
          letter-spacing: 1px;
          line-height: 31px;
          color: rgba(56, 56, 56, 1);
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          a {
            font-size: var(--footer-font-size);
            font-weight: 400;
            letter-spacing: 1px;
            line-height: 31px;
            color: rgba(56, 56, 56, 1);
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }
        }
      }
    }
  }

  .right-box {
    display: flex;
    justify-content: center;
    gap: 20px;
    .img-box{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: var(--footer-font-size);
      img{
        width: 144px;
      }
    }
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  padding-top: 30px;
  text-align: center;
  font-size: var(--footer-font-size);
  color: #fff;
  font-weight: bolder;
  background: rgba(87, 174, 204, 1);
  white-space: nowrap;
  overflow: hidden;

  a {
    outline: none;
    color: #fff;
  }

  b {
    margin: 0 20px;
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 16px;
    background: #ffffff;
  }

  img {
    margin-right: 8px;
    width: 28px;
    height: 28px;
    display: inline-block;
    vertical-align: middle;
  }
}

/* 媒体查询部分 */
@media (min-resolution: 1.25dppx) {
  .footer-container {
    --footer-font-size: 12px;
  }
}

/* 确保在1600px及以上宽度时能够完整显示 */
@media screen and (min-width: 1600px) {
  .link-box {
    max-width: 1920px;
    margin: 20px auto 0 auto;
    padding: 42px;
  }

  .link-box .center-box {
    flex: 1;
    min-width: 400px;
  }

  .link-box .right-box .img-box img {
    width: 144px;
  }
}

/* 小于1600px的样式调整 */
@media screen and (max-width: 1599px) {
  .link-box {
    max-width: 1600px;
    margin: 20px auto 0 auto;
    padding: 20px;
  }

  .link-box .left-box img {
    width: 180px;
  }

  .link-box .center-box {
    flex: 1;
    min-width: 400px;
    gap: 8px;
    padding: 0 12px;
  }

  .link-box .link-box-item {
    padding: 12px 8px;
  }

  .link-box .right-box {
    gap: 8px;
  }

  .link-box .right-box .img-box {
    margin: 0 5px;
  }

  .link-box .right-box .img-box img {
    width: 90px;
  }
}

/* 确保在任何分辨率下元素都不会重叠 */
@media screen and (max-width: 1399px) {
  .link-box {
    padding: 20px 15px;
  }

  .link-box .left-box img {
    width: 160px;
  }

  .link-box .center-box {
    gap: 5px;
    padding: 0 10px;
  }

  .link-box .link-box-item {
    padding: 10px 5px;
  }

  .link-box .right-box {
    gap: 5px;
  }

  .link-box .right-box .img-box {
    margin: 0 5px;
  }

  .link-box .right-box .img-box img {
    width: 90px;
  }
}

/* 在1300px以下时进一步优化 */
@media screen and (max-width: 1299px) {
  .link-box {
    padding: 15px 10px;
  }

  .link-box .left-box img {
    width: 140px;
  }

  .link-box .center-box {
    min-width: 350px;
    padding: 0 8px;
  }

  .link-box .link-box-item {
    padding: 8px 3px;
  }

  .link-box .right-box .img-box img {
    width: 80px;
  }

  .link-box .right-box .img-box {
    font-size: 10px;
    margin: 0 3px;
  }
}

/* 最小兼容到1200px */
@media screen and (max-width: 1200px) {
  .footer-container {
    --footer-img-margin: 0 20px;
  }

  .link-box {
    padding: 15px 10px;
  }

  .link-box .left-box img {
    width: 120px;
  }

  .link-box .center-box {
    min-width: 300px;
    padding: 0 5px;
    gap: 5px;
  }

  .link-box .link-box-item {
    padding: 5px 2px;
  }

  .link-box .right-box .img-box img {
    width: 70px;
  }
}
</style>
